import { Skeleton } from '@mui/material'
import clsx from 'clsx'
import { LoadingTable } from 'components/core-v2'

import { COLUMN_DEFS } from './columns'
import classes from './index.module.scss'

export const NameLoadingCell = () => (
  <div className={clsx(classes.loadingCell, classes.nameLoadingCell)}>
    <Skeleton className="mb-1" height="15px" variant="rectangular" width="240px" />
    <Skeleton height="15px" variant="rectangular" width="140px" />
  </div>
)

export const Last30DaysLoadingCell = () => (
  <div className={clsx(classes.loadingCell, classes.last30DaysLoadingCell)}>
    <Skeleton className="mr-4" height="15px" variant="rectangular" width="60px" />
    <Skeleton height="48px" variant="rectangular" width="240px" />
  </div>
)

export const Loading = () => (
  <LoadingTable
    agGridProps={{
      columnDefs: COLUMN_DEFS,
      headerHeight: 60,
      rowHeight: 88
    }}
  />
)
